module.exports = __webpack_public_path__ + "img/9788971994948.b9e24c56.jpg";